import axios from "axios";
import { Base_URL } from "../url";

// Get all resources
export const fetchAllResources = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectResourceMaster/GetAllResources`,
    );
    return response.data;
  } catch (error) {
    // Return empty array for 404 instead of throwing error
    if (error.response?.status === 404) {
      return [];
    }
    throw error.response?.data || "Error fetching resources!";
  }
};

// Get resources by project
export const fetchResourcesByProject = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectResourceMaster/GetResourcesByProject/${projectId}`,
    );
    return response.data;
  } catch (error) {
    // Return empty array for 404 instead of throwing error
    if (error.response?.status === 404) {
      return [];
    }
    throw error.response?.data || "Error fetching resources by project!";
  }
};

// Get resources by organization
export const fetchResourcesByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectResourceMaster/GetResourcesByOrg/${orgId}`,
    );
    return response.data;
  } catch (error) {
    // Return empty array for 404 instead of throwing error
    if (error.response?.status === 404) {
      return [];
    }
    throw error.response?.data || "Error fetching resources by organization!";
  }
};

// Get resources by member
export const fetchResourcesByMember = async (memberId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectResourceMaster/GetResourcesByMember/${memberId}`,
    );
    return response.data;
  } catch (error) {
    // Return empty array for 404 instead of throwing error
    if (error.response?.status === 404) {
      return [];
    }
    throw error.response?.data || "Error fetching resources by member!";
  }
};

// Get active resources
export const fetchActiveResources = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectResourceMaster/GetActiveResources`,
    );
    return response.data;
  } catch (error) {
    // Return empty array for 404 instead of throwing error
    if (error.response?.status === 404) {
      return [];
    }
    throw error.response?.data || "Error fetching active resources!";
  }
};

// Get resource by ID
export const fetchResourceById = async (resourceId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectResourceMaster/GetResourceById/${resourceId}`,
    );
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    throw error.response?.data || "Error fetching resource details!";
  }
};

// Create new resource
export const createResource = async (resourceData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ProjectResourceMaster/CreateResource`,
      resourceData,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error creating resource!";
  }
};

// Update resource
export const updateResource = async (resourceId, resourceData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/ProjectResourceMaster/UpdateResource/${resourceId}`,
      resourceData,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating resource!";
  }
};

// Soft delete resource (sets IsActive = false)
export const softDeleteResource = async (resourceId) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/ProjectResourceMaster/SoftDeleteResource/${resourceId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error deleting resource!";
  }
};

// Restore resource (sets IsActive = true)
export const restoreResource = async (resourceId) => {
  try {
    const response = await axios.put(
      `${Base_URL}/ProjectResourceMaster/RestoreResource/${resourceId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error restoring resource!";
  }
};

// Permanent delete resource (hard delete)
export const permanentDeleteResource = async (resourceId) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/ProjectResourceMaster/PermanentDeleteResource/${resourceId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error permanently deleting resource!";
  }
};

// Keep the original deleteResource for backward compatibility (now uses soft delete)
export const deleteResource = async (resourceId) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/ProjectResourceMaster/DeleteResource/${resourceId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error deleting resource!";
  }
};

// Get resource master by organization
export const fetchResourceMasterByOrg = async (organisationId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectResourceMaster/GetResourceMasterByOrg/${organisationId}`,
    );
    return response.data;
  } catch (error) {
    // Return empty array for 404
    if (error.response?.status === 404) {
      return [];
    }
    throw (
      error.response?.data || "Error fetching resource master by organization!"
    );
  }
};

// =========================================================================
// PROJECT RESOURCE ROLE MASTER APIs
// =========================================================================

// Get roles by organization
export const fetchRolesByOrganisation = async (organisationId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectResourceRoleMaster/GetRolesByOrganisation/${organisationId}`,
    );
    return response.data;
  } catch (error) {
    // Return empty array for 404
    if (error.response?.status === 404) {
      return [];
    }
    throw error.response?.data || "Error fetching roles by organisation!";
  }
};

// Get role by GUID
export const fetchRoleByGuid = async (roleGuid) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectResourceRoleMaster/GetRoleByGuid/${roleGuid}`,
    );
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    throw error.response?.data || "Error fetching role by GUID!";
  }
};

// import axios from "axios";
// import { Base_URL } from "../url";

// // Get all resources
// export const fetchAllResources = async () => {
//   try {
//     const response = await axios.get(
//       `${Base_URL}/ProjectResourceMaster/GetAllResources`
//     );
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || "Error fetching resources!";
//   }
// };

// // Get resources by project
// export const fetchResourcesByProject = async (projectId) => {
//   try {
//     const response = await axios.get(
//       `${Base_URL}/ProjectResourceMaster/GetResourcesByProject/${projectId}`
//     );
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || "Error fetching resources by project!";
//   }
// };

// // Get resources by organization
// export const fetchResourcesByOrg = async (orgId) => {
//   try {
//     const response = await axios.get(
//       `${Base_URL}/ProjectResourceMaster/GetResourcesByOrg/${orgId}`
//     );
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || "Error fetching resources by organization!";
//   }
// };

// // Get resources by member
// export const fetchResourcesByMember = async (memberId) => {
//   try {
//     const response = await axios.get(
//       `${Base_URL}/ProjectResourceMaster/GetResourcesByMember/${memberId}`
//     );
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || "Error fetching resources by member!";
//   }
// };

// // Get active resources
// export const fetchActiveResources = async () => {
//   try {
//     const response = await axios.get(
//       `${Base_URL}/ProjectResourceMaster/GetActiveResources`
//     );
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || "Error fetching active resources!";
//   }
// };

// // Get resource by ID
// export const fetchResourceById = async (resourceId) => {
//   try {
//     const response = await axios.get(
//       `${Base_URL}/ProjectResourceMaster/GetResourceById/${resourceId}`
//     );
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || "Error fetching resource details!";
//   }
// };

// // Create new resource
// export const createResource = async (resourceData) => {
//   try {
//     const response = await axios.post(
//       `${Base_URL}/ProjectResourceMaster/CreateResource`,
//       resourceData
//     );
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || "Error creating resource!";
//   }
// };

// // Update resource
// export const updateResource = async (resourceId, resourceData) => {
//   try {
//     const response = await axios.put(
//       `${Base_URL}/ProjectResourceMaster/UpdateResource/${resourceId}`,
//       resourceData
//     );
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || "Error updating resource!";
//   }
// };

// // Delete resource
// export const deleteResource = async (resourceId) => {
//   try {
//     const response = await axios.delete(
//       `${Base_URL}/ProjectResourceMaster/DeleteResource/${resourceId}`
//     );
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || "Error deleting resource!";
//   }
// };

// // Get resource master by organization
// export const fetchResourceMasterByOrg = async (organisationId) => {
//   try {
//     const response = await axios.get(
//       `${Base_URL}/ProjectResourceMaster/GetResourceMasterByOrg/${organisationId}`
//     );
//     return response.data;
//   } catch (error) {
//     throw (
//       error.response?.data || "Error fetching resource master by organization!"
//     );
//   }
// };
